export default "__VITE_ASSET__57567ff8__"